import { Menu as AntMenu } from "antd"
import type { MenuProps } from "antd"
import { MenuProvider } from "components/providers/Menu.provider"

type Props = {
	items: MenuProps["items"]
	onClick: MenuProps["onClick"]
	styles?: React.CSSProperties
	mode?: MenuProps["mode"]
	inlineCollapsed?: boolean
	defaultOpenKeys?: string[]
	selectedKeys?: string[]
	className?: string
}

export const Menu = ({
	items,
	onClick,
	styles,
	mode,
	inlineCollapsed,
	defaultOpenKeys,
	selectedKeys,
	className,
}: Props) => {
	return (
		<MenuProvider>
			<AntMenu
				items={items}
				onClick={onClick}
				style={styles}
				mode={mode}
				inlineCollapsed={inlineCollapsed}
				defaultOpenKeys={defaultOpenKeys}
				selectedKeys={selectedKeys}
				className={className}
			/>
		</MenuProvider>
	)
}
